import React, { useCallback } from 'react';
import { IEditForm } from '../../types/interfaces/IEditForm';
import { TextField, Typography, Box } from '@material-ui/core';
import { stylesConstants } from '../../styles/stylesConstants';

const InputForm: React.FC<IEditForm> = ({
  onChange,
  value,
  fieldName,
  multiline,
  label,
  textFieldType,
  error,
  errorText,
  fullWidth = false,
  placeholder,
  hiddenLabel = false,
  hidden = false,
  uppercased = false,
}) => {
  const handleOnChange = useCallback(
    (event: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>) => {
      const value = uppercased ? event.target.value?.toUpperCase() : event.target.value;
      onChange ? onChange(fieldName, value) : () => null;
    },
    [fieldName, onChange],
  );

  if (hidden) return null;

  return (
    <>
      {label && (
        <Box
          marginBottom={1}
          style={{
            height: hiddenLabel ? 0 : 'unset',
            overflow: 'hidden',
            marginBottom: hiddenLabel ? 0 : 8,
          }}
        >
          <Typography variant="subtitle2">{label}</Typography>
        </Box>
      )}
      <TextField
        id={fieldName}
        name={fieldName}
        onChange={handleOnChange}
        value={value || ''}
        multiline={multiline}
        rows={multiline ? 6 : 1}
        type={textFieldType}
        error={error}
        helperText={errorText}
        placeholder={placeholder || ''}
        style={{
          width: fullWidth ? '100%' : stylesConstants.inputFormWidth,
          opacity: hiddenLabel ? 0 : 1,
          height: hiddenLabel ? 0 : 'unset',
        }}
      />
    </>
  );
};

export default InputForm;
